export function getTireAvailabilityBadge(product) {
  const visibility = product && product.visibility;
  const euStock = Boolean(product && product.source === "georgia");

  if (visibility === "outofstock") {
    return { kind: "out", label: "לא במלאי" };
  }

  if (euStock) {
    return { kind: "eu", label: "מלאי אירופה" };
  }

  if (visibility === "instock") {
    return { kind: "local", label: "במלאי" };
  }

  if (visibility === "preorder") {
    return { kind: "preorder", label: "מגיע במשלוח הקרוב" };
  }

  if (visibility === "ondemand") {
    return { kind: "ondemand", label: "הזמנה מראש" };
  }

  return { kind: "out", label: "לא במלאי" };
}
